import { Grid, Tabs, Tab } from "@mui/material";
import { observer } from "mobx-react";
import { styled } from "@mui/material/styles";
import MyPageStore from "pages/MyPage/store/MyPageStore";
import React from "react";

const CustomTabs = styled(Tabs)`
  color: #ababab;

  .css-1a4240h-MuiButtonBase-root-MuiTab-root.Mui-selected {
    color: #000000;
  }
`;

const CustomTab = styled(Tab)`
  color: #ababab;

  & .Mui-selected {
    color: #000000;
  }
`;

interface MyPageTopTabsProps {
  pageStore: MyPageStore;
}

function MyPageTopTabs(props: MyPageTopTabsProps) {
  const [value, setValue] = React.useState("downwards");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    props.pageStore.setTabValue(newValue);
    props.pageStore.fetchTaskListOfStatus(props.pageStore.myInfo);
  };
  return (
    <Grid container item direction="column" rowGap={2}>
      <CustomTabs
        value={props.pageStore.tabValue}
        onChange={handleChange}
        variant="fullWidth"
        aria-label="topTabs_Home"
        TabIndicatorProps={{
          sx: {
            background: "black",
          },
        }}
      >
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"downwards"}
          label="Downwards"
        />
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"peer"}
          label="Peer"
        />
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"all"}
          label="All"
        />
      </CustomTabs>
    </Grid>
  );
}

export default observer(MyPageTopTabs);
